/** NTES-QSF-SAL-01 parameter keys/labels — keep aligned with backend constants. */

export const CSS_FORM_CODE = 'NTES-QSF-SAL-01';
export const CSS_MAX_SCORE_B = 30;

export const CSS_PARAMETER_KEYS = [
  'quality_of_work',
  'ontime_delivery',
  'technical_knowledge',
  'understanding_requirements',
  'communication_response',
  'occupational_health_safety',
] as const;

export type CssParameterKey = (typeof CSS_PARAMETER_KEYS)[number];

export const CSS_PARAMETER_LABELS: Record<CssParameterKey, string> = {
  quality_of_work: 'Quality of work',
  ontime_delivery: 'Ontime delivery',
  technical_knowledge: 'Technical Knowledge and competency of team',
  understanding_requirements: 'Understanding of client Requirements',
  communication_response:
    'Communication with client representatives and timely response to client enquiries',
  occupational_health_safety: 'Occupational Health and Safety',
};

export const CSS_SCORE_OPTIONS = [
  { value: 1, label: '1 — Poor – Not Acceptable' },
  { value: 2, label: '2 — Fair – Requires Improvement' },
  { value: 3, label: '3 — Acceptable' },
  { value: 4, label: '4 — Good' },
  { value: 5, label: '5 — Excellent' },
];

export type CssParameterScore = { score: number | null; comments?: string | null };
export type CssParameterScores = Record<CssParameterKey, CssParameterScore>;

export function emptyParameterScores(): CssParameterScores {
  return CSS_PARAMETER_KEYS.reduce((acc, key) => {
    acc[key] = { score: null, comments: null };
    return acc;
  }, {} as CssParameterScores);
}

export type CustomerSatisfactionSurvey = {
  id: string;
  survey_number?: string;
  form_code?: string;
  status: string;
  customer_id: string;
  customer_name?: string;
  customer_name_snapshot?: string | null;
  customer_address?: string | null;
  scope_of_work?: string | null;
  project_or_po_reference?: string | null;
  feedback_date?: string | null;
  sales_order_id?: string | null;
  sales_order_number?: string | null;
  delivery_note_id?: string | null;
  parameter_scores?: CssParameterScores;
  overall_comments?: string | null;
  client_rep_name?: string | null;
  client_rep_email?: string | null;
  client_rep_signature?: string | null;
  client_rep_date?: string | null;
  total_score_a?: number | null;
  max_score_b?: number | null;
  satisfaction_pct?: number | null;
  kpi_target_pct?: number | null;
  satisfaction_result?: 'Satisfied' | 'Unsatisfied' | null;
  requires_ncr?: boolean;
  ncr_id?: string | null;
  sales_notes?: string | null;
  access_token?: string | null;
  share_path?: string | null;
  share_token?: string | null;
  sent_at?: string | null;
  completed_at?: string | null;
  reviewed_at?: string | null;
  created_at?: string;
};
